if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
        }

        // Collect main product variant id
        const mainVariantId = Number(this.form.querySelector('[name=id]').value);

        // Detect whether any file input attached to this form has a selected file.
        // /cart/add.js with JSON cannot carry files; we need to fall back to
        // multipart/form-data for the main item when files are present.
        const formFileInputs = Array.from(this.form.elements).filter((el) =>
          el && el.type === 'file' && el.files && el.files.length > 0
        );
        const hasFiles = formFileInputs.length > 0;

        // Collect line-item properties from the form (includes external inputs that
        // reference the form via the form="..." attribute, e.g. custom-field-block,
        // checkbox-block). Skip empty values and unchecked checkboxes.
        const mainProperties = {};
        const formData = new FormData(this.form);
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (!match) continue;
          const propName = match[1];
          if (typeof value === 'string' && value.trim() === '') continue;
          if (value instanceof File && value.size === 0) continue;
          mainProperties[propName] = value;
        }
        const mainItem = { id: mainVariantId, quantity: 1 };
        if (!hasFiles && Object.keys(mainProperties).length > 0) {
          mainItem.properties = mainProperties;
        }

        // Collect checked cross-sell items (skip the first item = main product)
        const crossSellItems = [];
        let isFirst = true;
        document.querySelectorAll('lumin-cross-sells input[type="checkbox"]').forEach((checkbox) => {
          if (isFirst) { isFirst = false; return; } // skip main product row
          if (!checkbox.checked) return;
          const listItem = checkbox.closest('[data-cross-sells-list-item]');
          if (!listItem) return;
          const selectEl = listItem.querySelector('select[name="variant-id"]');
          const hiddenEl = listItem.querySelector('input[type="hidden"][name="variant-id"]');
          const id = Number(selectEl ? selectEl.value : hiddenEl ? hiddenEl.value : 0);
          if (id) crossSellItems.push({ id, quantity: 1 });
        });

        // Build items array: main product first
        const allItems = [mainItem, ...crossSellItems];

        // Build sections for cart render
        let sections = [];
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map((section) => section.id);
          this.cart.setActiveElement(document.activeElement);
        }

        // Pick request strategy: multipart when files are present (one item per
        // call), otherwise JSON bulk add.
        const cartAddUrl = `${window.Shopify.routes.root}cart/add.js`;
        let primaryRequest;
        if (hasFiles) {
          const multipartBody = new FormData();
          multipartBody.append('id', String(mainVariantId));
          multipartBody.append('quantity', '1');
          for (const [key, value] of formData.entries()) {
            if (!/^properties\[(.+)\]$/.test(key)) continue;
            if (typeof value === 'string' && value.trim() === '') continue;
            if (value instanceof File && value.size === 0) continue;
            multipartBody.append(key, value);
          }
          if (sections.length) {
            multipartBody.append('sections', sections.join(','));
            multipartBody.append('sections_url', window.location.pathname);
          }
          primaryRequest = fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: multipartBody,
          })
            .then((r) => r.json())
            .then((mainResponse) => {
              if (mainResponse.status) return mainResponse;
              if (crossSellItems.length === 0) return mainResponse;
              return fetch(cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ items: crossSellItems, sections, sections_url: window.location.pathname }),
              })
                .then((r) => r.json())
                .then((followUp) => {
                  if (followUp.status) return followUp;
                  if (followUp.sections) mainResponse.sections = followUp.sections;
                  return mainResponse;
                });
            });
        } else {
          primaryRequest = fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: allItems, sections, sections_url: window.location.pathname }),
          }).then((response) => response.json());
        }

        primaryRequest
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              // Com o checkout Yampi ativo, vai para o carrinho (a Yampi
              // assume a finalização a partir de lá).
              window.location = window.__ympActive ? "/cart" : "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
